import getAll from './getAll';
import deletes from './delete';
import create from './create';
import getMeta from './getMeta';
import getCoupon from './getCoupon';
export default {
  getAll,
  getMeta,
  deletes,
  create,
  getCoupon,
};
